import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input, Label } from "../components/ui/input";
import api, { formatApiErrorDetail } from "../lib/api";

export default function Register() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user) {
    navigate("/dashboard", { replace: true });
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/api/auth/register", { name, email, password });
      await login(email, password);
      toast.success("Account creato");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response ? formatApiErrorDetail(err.response.data?.detail) : err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-6 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center bg-brand text-white">
            <Sparkles className="h-6 w-6" />
          </div>
          <span className="font-display text-lg font-extrabold tracking-tight">AGENT BUILDER</span>
        </div>
        <div className="mb-8">
          <h2 className="font-display text-3xl font-black tracking-tight text-ink">Crea un account</h2>
          <p className="mt-2 text-sm text-slate-500">Costruisci il tuo agente con avatar, voce e azioni.</p>
        </div>
        <form onSubmit={submit} className="space-y-5" data-testid="register-form">
          <div className="space-y-1.5">
            <Label htmlFor="name">Nome</Label>
            <Input
              id="name" autoComplete="name" placeholder="Mario Rossi"
              value={name} onChange={(e) => setName(e.target.value)} required
              data-testid="register-name-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email" type="email" autoComplete="username" placeholder="nome@azienda.it"
              value={email} onChange={(e) => setEmail(e.target.value)} required
              data-testid="register-email-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password" type="password" autoComplete="new-password" placeholder="Almeno 8 caratteri"
              value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8}
              data-testid="register-password-input"
            />
          </div>
          <Button type="submit" size="lg" className="w-full" disabled={loading} data-testid="register-submit-btn">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Crea account"}
          </Button>
        </form>
        <p className="mt-6 text-center text-sm text-slate-500">
          Hai già un account? <Link to="/login" className="font-medium text-brand hover:underline">Accedi</Link>
        </p>
      </div>
    </div>
  );
}
